/**
 * App layout styles - main container and structure.
 * Colors come from MUI theme.
 */

import { SxProps, Theme } from '@mui/material';

export const appLayoutStyles: Record<string, SxProps<Theme>> = {
  rootContainer: {
    height: '100%',
    minWidth: '350px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    bgcolor: 'background.paper',
    color: 'text.primary',
    '& > *:not([data-dialog-container])': {
      overflow: 'hidden',
    },
  },
  mainContent: {
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
  },
  tabContent: {
    flex: 1,
    overflow: 'hidden',
  },
};
